module.exports = __webpack_public_path__ + "static/media/wf.3d73a607.svg";